<div class="grid">
  <ng-container *ngFor="let highlight of this.highlightCollections">
    <div class="xs-12 m-6">
      <div
        [routerLink]="['/collections/collection-detail', highlight.id]"
        class="collection item"
      >
        <div class="img-wrapper">
          <img src="{{ highlight.images.highlight | image }}" loading="lazy" />
        </div>
        <h3 class="title">{{ highlight.texts.title | i18next }}</h3>
      </div>
    </div>
  </ng-container>
</div>
